import { Modal } from "antd";
import { Calendar, AlertTriangle, X } from "lucide-react";
import IMAGES from "../../constants/images";

const EditPopup = ({
  isOpen,
  onClose,
  time,
  editDialog,
  setEditDialog,
  editpop,
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={() => onClose(false)}
      footer={null}
      width={480}
      centered
      closeIcon={<X className="w-6 h-6 text-gray-700" />}
      className="manage-slot-modal"
      maskStyle={{ backgroundColor: "rgba(55, 65, 81, 0.9)" }}
      bodyStyle={{ padding: 0 }}
    >
      <div className="relative transform scale-[0.9] origin-top-left w-[111.11%]">
        <div className="p-0 pt-8 flex flex-col items-center">
          {/* Calendar icon */}
          <div className="w-24 h-24 rounded-full bg-blue-50 flex items-center justify-center mb-2">
            <div className="w-16 h-16">
              <img src={IMAGES.manage_unavailable} />
            </div>
          </div>

          {/* Title */}
          <h2 className="text-[24px] font-poppins  font-semibold text-[#4B61FF] mb-6">
            Manage Unavailability
          </h2>

          {/* Divider */}
          <div className="w-full h-px bg-gray-200 mb-6"></div>

          {/* Time slot info */}
          <p className="text-[#171717] font-poppins font-semibold text-[18px]  mb-2">
            You're marked as unavailable on:
          </p>
          <div className="flex  items-center justify-center gap-2 mb-4">
            <Calendar className="w-5 h-5 text-gray-500" />
            <span className="font-normal text-[#171717] font-poppins text-[16px]">
              {time}
            </span>
          </div>

          {/* Divider */}
          <div className="w-full h-px bg-gray-200 mb-6"></div>

          {/* Warning message */}
          <div className="bg-[#EFF6FF] p-2 rounded-md flex justify-center items-center gap-3 mb-6 w-full">
            <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5 ml-10" />
            <span className="text-[#64748B]  text-[14px] font-poppins font-400 w-full">
              Editing or deleting this slot may affect scheduled appointments.
              Proceed with caution.
            </span>
          </div>

          {/* Action buttons */}
          <div className="flex gap-4 w-full">
            <button
              className="flex-1 py-3 border border-gray-300 rounded-md font-medium bg-[#ffffff] text-[#171717] border-[989898] font-poppins"
              onClick={() => {
                onClose();
                // setEditDialog(!editDialog);
                editpop(true);
              }}
            >
              Edit Unavailability
            </button>
            <button
              className="flex-1 py-3 btn-gradient text-white rounded-xl font-poppins"
              onClick={() => {
                onClose();
                setEditDialog(true);
              }}
            >
              Delete Unavailability
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditPopup;
